import React from 'react';
import CrudPage from '../../components/CrudPage';
import { addressesTrackerApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'id' },
  { header: 'Address ID', field: 'addressId' },
  { header: 'Investor ID', field: 'investorId' },
  { header: 'Status', field: 'status' },
  { header: 'Updated', field: 'updatedAt', type: 'date' },
];

const formFields = [
  { name: 'addressId', label: 'Address ID', type: 'number', required: true },
  { name: 'investorId', label: 'Investor ID', type: 'text' },
  { name: 'status', label: 'Status', type: 'text' },
];

const AddressesTrackerPage = () => (
  <CrudPage
    title="Address Tracker"
    subtitle="Track address changes"
    api={addressesTrackerApi}
    columns={columns}
    formFields={formFields}
    idField="id"
  />
);

export default AddressesTrackerPage;
